import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function generateApplicationPDF(application) {
  const doc = new jsPDF();
  const { businessInfo, owners, dbas, bankingInfo, processingInfo } = application;

  const section = (title, rows) => {
    doc.setFontSize(14);
    doc.text(title, 14, doc.lastAutoTable ? doc.lastAutoTable.finalY + 10 : 20);
    autoTable(doc, {
      startY: doc.lastAutoTable ? doc.lastAutoTable.finalY + 15 : 25,
      head: [["Field", "Value"]],
      body: rows,
      styles: { fontSize: 10 },
    });
  };

  section("Business Info", Object.entries(businessInfo || {}));

  // DBAs
  if (dbas?.length > 0) {
    dbas.forEach((dba, i) => {
      const label = dbas.length > 1 ? `DBA ${i + 1}` : "DBA";
      const entries = Object.entries(dba || {}).filter(([k]) => k !== "dbaId" && k !== "isActive");
      section(label, entries);
    });
  }

  // Owners (v2) or ownerInfo (v1 fallback)
  if (owners?.length > 0) {
    owners.forEach((owner, i) => {
      const label = owners.length > 1 ? `Owner ${i + 1}` : "Owner Info";
      const entries = Object.entries(owner || {}).filter(([k]) => k !== "ownerId");
      section(label, entries);
    });
  } else if (application.ownerInfo) {
    section("Owner Info", Object.entries(application.ownerInfo || {}));
  }

  section("Banking Info", Object.entries(bankingInfo || {}));
  section("Processing Info", Object.entries(processingInfo || {}));

  doc.save("application-summary.pdf");
}

// utilities/formatDateForQuery.js
export function formatDateForQuery(input, endOfDay = false) {
  const pad = (n) => String(n).padStart(2, "0");

  // Handle YYYY-MM-DD string
  if (typeof input === "string" && /^\d{4}-\d{2}-\d{2}$/.test(input)) {
    return endOfDay ? `${input} 23:59:59` : `${input} 00:00:00`;
  }

  // Otherwise assume it's a Date
  const date = input instanceof Date ? input : new Date(input);

  return (
    date.getFullYear() +
    "-" +
    pad(date.getMonth() + 1) +
    "-" +
    pad(date.getDate()) +
    " " +
    pad(date.getHours()) +
    ":" +
    pad(date.getMinutes()) +
    ":" +
    pad(date.getSeconds())
  );
}
